module.exports = __webpack_public_path__ + "static/media/Internationalpic1.ad319702.png";